import { render, staticRenderFns } from "./CommunityRibbonActionButtons.vue?vue&type=template&id=5fd15432&scoped=true&"
import script from "./CommunityRibbonActionButtons.vue?vue&type=script&lang=js&"
export * from "./CommunityRibbonActionButtons.vue?vue&type=script&lang=js&"
import style0 from "./CommunityRibbonActionButtons.vue?vue&type=style&index=0&id=5fd15432&lang=scss&scoped=true&"
import style1 from "./CommunityRibbonActionButtons.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd15432",
  null
  
)

export default component.exports